import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'zh-CN', label: '简体中文' },
  { code: 'en', label: 'English' },
] as const;

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [current, setCurrent] = useState(i18n.language || 'zh-TW');

  useEffect(() => {
    const handleLanguageChanged = (lng: string) => setCurrent(lng);
    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n]);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const lng = event.target.value;
    i18n.changeLanguage(lng).then(() => {
      document.documentElement.lang = lng;
    });
  };

  return (
    <select
      value={current}
      onChange={handleChange}
      className="bg-transparent text-sm font-medium text-gray-700 hover:text-[#0a4c6b] border border-gray-300 rounded-lg px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[#0a4c6b] cursor-pointer"
      aria-label="Select language"
    >
      {languages.map((lng) => (
        <option key={lng.code} value={lng.code}>
          {lng.label}
        </option>
      ))}
    </select>
  );
}
